import React, { useState, useEffect } from 'react';
import { T, font, mono, STATUS } from '../utils/theme';
import * as api from '../utils/api';
import { Card, Sect } from './UI';

export default function SupplierDashboard({ lang, supplier, products, Lk }) {
  const [activity, setActivity] = useState([]);

  useEffect(() => {
    api.getActivity(supplier.id).then(setActivity).catch(() => {});
  }, [supplier.id]);

  const canSee = p => !p.restrict_supplier || p.restrict_supplier === supplier.id;
  const toQuote = products.filter(p => p.status === 'quoting' && canSee(p) && !(p.quotes?.[supplier.id]?.available));
  const quoted = products.filter(p => p.status === 'quoting' && canSee(p) && p.quotes?.[supplier.id]?.available);
  const assigned = products.filter(p => p.status === 'supplier_assigned' && p.assigned_supplier === supplier.id);
  const accepted = products.filter(p => p.status === 'ordering' && p.assigned_supplier === supplier.id && !p.shipment_status);

  const actColors = { confirmed: STATUS.ordering.color, newQuotes: STATUS.quoting.color, newAssigned: STATUS.supplier_assigned.color, shipped: T.success, price_change: T.warn, shipment_deleted: T.danger,
    variantProposed: T.warn, variantOpened: T.success, variantRejected: T.dim, supplierNote: T.accent };
  const actIcons = { confirmed: '✓', newQuotes: '★', newAssigned: '⚡', shipped: '📦', price_change: '✎', shipment_deleted: '🗑',
    variantProposed: '＋', variantOpened: '📢', variantRejected: '—', supplierNote: '💬' };
  const actLabels = { confirmed: lang === 'zh' ? '已确认' : 'Confirmed', newQuotes: lang === 'zh' ? '新报价' : 'New Quote', newAssigned: lang === 'zh' ? '已分配' : 'Assigned', shipped: lang === 'zh' ? '已发货' : 'Shipped', price_change: lang === 'zh' ? '价格变更' : 'Price Change', shipment_deleted: lang === 'zh' ? '物流已删除' : 'Shipment Deleted',
    variantProposed: lang === 'zh' ? '已提交版本' : 'Version suggested', variantOpened: lang === 'zh' ? '版本已开放' : 'Version opened to all',
    variantRejected: lang === 'zh' ? '版本未采用' : 'Version not needed', supplierNote: lang === 'zh' ? '备注' : 'Note sent' };

  return (
    <div>
      <h2 style={{ margin: '0 0 22px', fontSize: 22, fontWeight: 900, color: T.text }}>{Lk('dashboard')}</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 24 }}>
        {[
          { v: toQuote.length, l: lang === 'zh' ? '待报价' : 'To Quote', c: T.warn },
          { v: assigned.length, l: lang === 'zh' ? '待确认' : 'To Confirm', c: T.accent },
          { v: quoted.length, l: Lk('quoted'), c: T.success },
          { v: accepted.length, l: lang === 'zh' ? '准备中' : 'Preparing', c: T.purple },
        ].map((s, i) => (
          <Card key={i}>
            <div style={{ fontSize: 28, fontWeight: 900, color: s.c, lineHeight: 1 }}>{s.v}</div>
            <div style={{ fontSize: 11, color: T.muted, fontWeight: 700, marginTop: 5, textTransform: 'uppercase' }}>{s.l}</div>
          </Card>
        ))}
      </div>
      <Sect title={Lk('recentActivity')}>
        {activity.length === 0 ? <div style={{ color: T.dim, fontSize: 13, fontStyle: 'italic' }}>{Lk('noActivity')}</div> :
          activity.slice(0, 15).map(a => (
            <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', marginBottom: 4, background: T.surface, borderRadius: 8, border: `1px solid ${T.border}`, borderLeft: `3px solid ${actColors[a.type] || T.dim}` }}>
              <span style={{ fontSize: 16, width: 24, textAlign: 'center' }}>{actIcons[a.type] || '•'}</span>
              <div style={{ flex: 1 }}>
                <span style={{ color: actColors[a.type] || T.text, fontWeight: 700, fontSize: 13 }}>{actLabels[a.type] || a.type}</span>
                <span style={{ color: T.muted, marginLeft: 8, fontSize: 13 }}>— {a.product_name}</span>
              </div>
              <span style={{ fontSize: 11, color: T.dim, fontFamily: mono }}>{a.date} {a.time}</span>
            </div>
          ))}
      </Sect>
    </div>
  );
}
